import './stillSubscribed.scss';

const StillSubscribed = ({ t, onGoHome }) => {
    return (
        <>
            <h2 className="unsubscribe__still__title">{t.text1}</h2>
            <p className="unsubscribe__still__subtitle">{t.text2}</p>
            <button
                onClick={onGoHome}
                className="unsubscribe__button"
            >
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                {t.button}
            </button>
        </>
    );
};

export default StillSubscribed;